module.exports = __webpack_public_path__ + "img/portal-banner.ae33d845.png";